"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var _MuiIconButtonDialog = _interopRequireDefault(require("../../../MuiIconButtonDialog/MuiIconButtonDialog"));

var _MuiIconButtonHref = _interopRequireDefault(require("../../../MuiIconButtonHref/MuiIconButtonHref"));

var _MuiIconButtonRedirect = _interopRequireDefault(require("../../../MuiIconButtonRedirect/MuiIconButtonRedirect"));

var _GoogleConversions = _interopRequireDefault(require("../../../GoogleConversions/GoogleConversions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MuiGridListTileBar = function MuiGridListTileBar(_ref) {
  var actionIcon = _ref.actionIcon,
      titlePosition = _ref.titlePosition,
      rootClass = _ref.rootClass,
      subtitle = _ref.subtitle,
      title = _ref.title;
  var components = {
    MuiIconButtonDialog: _MuiIconButtonDialog.default,
    MuiIconButtonHref: _MuiIconButtonHref.default,
    MuiIconButtonRedirect: _MuiIconButtonRedirect.default,
    GoogleConversions: _GoogleConversions.default
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var renderAction = actionIcon.length !== 0 ? actionIcon[0] : null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.GridListTileBar, {
    title: title,
    subtitle: /*#__PURE__*/_react.default.createElement("span", null, subtitle),
    actionIcon: renderAction && /*#__PURE__*/(0, _react.createElement)(components[renderAction.component], _objectSpread({}, renderAction)),
    titlePosition: titlePosition,
    className: styles.root
  }));
};

var _default = MuiGridListTileBar;
exports.default = _default;
MuiGridListTileBar.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: node
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes.default.string,

  /**
   * mui prop: node
   * Title to be displayed on tile.
   */
  title: _propTypes.default.string,

  /**
   * mui prop: 'bottom', 'top'
   * Position of the title bar.
   */
  titlePosition: function titlePosition(props, propName, componentName) {
    var validProps = ['bottom', 'top'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * Content passed to render
   * components: MuiIconButtonRedirect
   */
  actionIcon: function actionIcon(props, propName, componentName) {
    var components = ['MuiIconButtonRedirect'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  }
};
MuiGridListTileBar.defaultProps = {
  rootClass: [],
  title: '',
  titlePosition: 'bottom',
  subtitle: '',
  actionIcon: []
};